import { render, staticRenderFns } from "./AnnotationList.vue?vue&type=template&id=a3f60a1c&scoped=true"
import script from "./AnnotationList.vue?vue&type=script&lang=js"
export * from "./AnnotationList.vue?vue&type=script&lang=js"
import style0 from "./AnnotationList.vue?vue&type=style&index=0&id=a3f60a1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f60a1c",
  null
  
)

export default component.exports